
import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';
@Component
export default class ListHistory extends Vue {
    @Prop({default: {}})
    private listItem: any;
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }
}
